import { useEffect, useState } from "react";
import { InfoBox } from "../../../../../ui/molecules/infoBox";
import { CustomRadio } from "../../../../../ui/molecules/radioButton";
import '../../../styles.scss'
import { useAppSelector } from "../../../../../lib/redux/hooks";
import { formatterDate, NotificationReleaseStatusOptions, NotificationTypeOptions, optionsFormatter } from "../../../../../utils";

export function NotifyStatusRight() {
    const notificationStatusState = useAppSelector(state => state.notificationStatus)
    const notificationStatusResponse = notificationStatusState.getNotificationStatusByIdResponse
    const [notifyCompliance, setNotifyCompliance] = useState<string | null>(null)

    useEffect(() => {
        if (notificationStatusResponse === undefined)
            return

        if (notificationStatusResponse.notificationValidation !== null)
            setNotifyCompliance(notificationStatusResponse.notificationValidation ? 'SI' : 'NO')
    }, [notificationStatusResponse])

    return (
        <div>
            <div className='text-left' style={{ padding: '24px 24px 12px 24px' }}>
                <span className='notify-title-bold' style={{ color: '#4D797F' }}>Stato </span>
                <span className='notify-title-bold' style={{ color: '#74A4A9' }}>/</span>
                <span className='notify-title-bold' style={{ color: '#314D51' }}> Dati Notifica</span>
            </div>

            <div style={{ padding: '0px 24px 18px 24px', borderBottomWidth: 1 }}>
                <InfoBox
                    color="green"
                    content={[
                        { title: 'Numero Notifica', label: notificationStatusResponse?.notificationIdentifier || '' },
                        { title: 'Data di rilascio', label: formatterDate(notificationStatusResponse?.notificationReleaseDate) || '' },
                        { title: 'Tipo', label: optionsFormatter(notificationStatusResponse?.notificationType!, NotificationTypeOptions) || '' },
                        { title: 'Stato', label: optionsFormatter(notificationStatusResponse?.notificationStatus!, NotificationReleaseStatusOptions) || '' },
                        { title: 'Protocollo', label: notificationStatusResponse?.notificationProtocolInfo || '' },
                    ]}
                />
            </div>

            <div className='text-left' style={{ padding: '12px 24px 12px 24px', borderBottomWidth: 1 }}>
                <div className='notify-subtitle mb-3'>
                    Stato Conformità Notifica
                </div>
                <div className="mb-5" style={{ display: 'flex', gap: '48px', alignItems: 'center' }}>
                    <span className='notify-text-content'>
                        Conformità Notifica
                    </span>
                    <div style={{ display: 'flex' }}>
                        <CustomRadio
                            disabled
                            options={[{ label: '', value: 'SI' }]}
                            selectedValue={notifyCompliance}
                            onChange={(value) => {
                                setNotifyCompliance(value)
                            }}
                            id={'notify_compliance_1'}
                            name={'notify_compliance_1'}
                        />
                        <div className='text-left'>
                            <span className='subtitle' style={{ color: '#5a8388' }}>Sì</span>
                        </div>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <CustomRadio
                            disabled
                            options={[{ label: '', value: 'NO' }]}
                            selectedValue={notifyCompliance}
                            onChange={(value) => {
                                setNotifyCompliance(value)
                            }}
                            id={'notify_compliance_2'}
                            name={'notify_compliance_2'}
                        />
                        <div className='text-left'>
                            <span className='subtitle' style={{ color: '#5a8388' }}>No</span>
                        </div>
                    </div>
                </div>

                <div className='text-left mb-5'>
                    <div className='notify-subtitle mb-3'>
                        Motivazione
                    </div>

                    <span className='notify-text-content'>
                        {notificationStatusResponse?.motivation || 'Nessuna motivazione indicata.'}
                    </span>
                </div>

                <div className='text-left mb-5'>
                    <div className='notify-subtitle mb-3'>
                        Note aggiuntive
                    </div>

                    <span className='notify-text-content'>
                        {notificationStatusResponse?.additionalNote || 'Nessuna nota indicata.'}
                    </span>
                </div>

                <div className='text-left mb-5' style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div className='notify-subtitle'>
                        Funzionario
                    </div>

                    <span className='notify-text-content'>
                        {notificationStatusResponse?.officerInfo || ''}
                    </span>
                </div>

                <div className='text-left mb-5' style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div className='notify-subtitle'>
                        Data di ultima modifica
                    </div>

                    <span className='notify-text-content'>
                        {formatterDate(notificationStatusResponse?.lastUpdate) || ''}
                    </span>
                </div>
            </div>
        </div>
    )
}